import styled from 'styled-components';

import theme from '@styles/theme';

export const SectionWrapper = styled.div<{
    $width?: string;
}>`
    width: ${({ $width }) => ($width ? $width : '100%')};
`;

export const SectionHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 0 0 12px;
`;
export const SectionContents = styled.div<{ $margin?: string }>`
    margin: ${({ $margin }) => ($margin ? $margin : 0)};
    width: inherit;
    border: ${theme.colors.ultraLightGrayBorder} 1px solid;
    border-radius: 2px;
`;
export const PlayListRow = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px;
    min-height: 68px;
`;
export const Thumbnail = styled.img<{ $width?: number; $height?: number }>`
    display: block;
    width: ${({ $width }) => ($width ? $width : 68)}px;
    height: ${({ $height }) => ($height ? $height : 36)}px;
    border-radius: 2px;
    object-fit: contain;
`;
export const MediaTitle = styled.div`
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
`;
export const NoticeContent = styled.div`
    white-space: pre-wrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* 2줄 넘어가면 말줄임 */
    -webkit-box-orient: vertical;
    line-height: 1.25;
`;
